import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs } from 'wsm-common-data';
import { UIContext } from '../contexts';
import { g } from '../global-constants';

const ContentColumnizer = ({ children, vehicles }) => {
	const { inputWidth } = useContext(UIContext);
	const { display } = usePrefs();
	const cleanedChildren = children.filter((n) => n);
	const singleColumnWidth = 600;
	// The panel host (e.g. the drawer) has a fixed, viewport-independent
	// width, so the viewport-derived breakpoint below is the wrong input --
	// panel mode always renders a single column (D9).
	const isDoubleColumn =
		display !== g.NAVIGATION_DRAWER && inputWidth > singleColumnWidth;
	const className = isDoubleColumn ? 'col-sm-6' : 'col-sm-12';

	function sortContent() {
		const leftColumn = [];
		const rightColumn = [];
		cleanedChildren.forEach((child, index) => {
			if (vehicles && child?.props?.vehicles && isDoubleColumn) {
				leftColumn.push(child);
			} else if (!vehicles && index % 2 === 0 && isDoubleColumn) {
				leftColumn.push(child);
			} else {
				rightColumn.push(child);
			}
		});
		return (
			<>
				<div className={className} data-testid="sts-input-column-one">
					{leftColumn}
				</div>
				<div className={className} data-testid="sts-input-column-two">
					{rightColumn}
				</div>
			</>
		);
	}

	return <div className={setClassNames(['row'])}>{sortContent()}</div>;
};

ContentColumnizer.propTypes = {
	children: PropTypes.node,
	vehicles: PropTypes.bool
};

export default ContentColumnizer;
